import { connect } from 'react-redux';
import { ItemsView } from './ItemsView';
import { plansSelector, fetchPlansIfNeeded as fetchAll } from '../../../data/plans';
import { popularPlansSelector, fetchPopularPlansIfNeeded as fetchPopular } from '../../../data/popular-plans';
import { getDropdownState } from '../../../data/dropdown-state';
import {
    choosePlan,
    showAllForTab,
    changeFocus,
    viewInsuranceTab,
    viewBcbsTab,
} from '../../../data/dropdown-state/dropdownStateActions';
import { sortBy } from 'lodash';
import { TAB, METRICS } from '../../../constants';
import { cleanPlan } from '../../../data/autocomplete/cleanPlan';
import { FLOW_SOURCE_ENUM } from '../../../data/dropdown-state/dropdownStateTracking';

function cleanPlans(plans, carrierRegex) {
    plans.forEach(plan => {
        plan.name = cleanPlan(plan.name, carrierRegex);
    });

    return sortBy(plans, ['name']);
}

export function mapStateToProps(state) {
    const baseConfig = {
        itemName: 'plans',
        isLoading: true,
        popularItems: [],
        allItems: [],
        metricsStep: METRICS.SELECTION_TYPE.PLAN,
        metricsAction: METRICS.CHANGE_PLAN,
        metricsDetailsIdField: METRICS.DETAILS_ID_FIELD.PLAN,
    };

    let allPlans = plansSelector(state);
    let popularPlans = popularPlansSelector(state);
    const dropdownState = getDropdownState(state);

    if ((!popularPlans || !popularPlans.length) && (!allPlans || !allPlans.length)) {
        return baseConfig;
    }

    if (!popularPlans || !popularPlans.length) {
        popularPlans = allPlans.slice(0, 5);
    }

    if (allPlans.length < 10) {
        popularPlans = allPlans;
    }

    if (allPlans.length === popularPlans.length) {
        allPlans = [];
    }

    const { carrier } = dropdownState;
    if (carrier) {
        const carrierRegex = new RegExp(carrier.name, 'gi');
        allPlans = cleanPlans(allPlans, carrierRegex);
        popularPlans = cleanPlans(popularPlans, carrierRegex);
    }

    return {
        ...baseConfig,
        ...dropdownState,
        isLoading: popularPlans.length === 0 && allPlans.length === 0,
        popularItems: popularPlans,
        allItems: allPlans,
        selected: dropdownState.plan || {},
        tab: dropdownState.tab,
        showAll: dropdownState.showAll[TAB.PLAN] === true,
        previousTab: props => () => {
            if (dropdownState.canSeeBcbs) {
                props.viewBcbsTab();
            } else {
                props.viewInsuranceTab();
            }
        },
    };
}

export const mapDispatchToProps = {
    fetchAll,
    fetchPopular,
    clickHandler: item => choosePlan(item, null, true, FLOW_SOURCE_ENUM.StepByStep),
    showAllForTab,
    changeFocus,
    viewInsuranceTab,
    viewBcbsTab,
};

export const PlansConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemsView);
